// Where to go after signing in: only a page of TUNE Analytics' own, and never back to a sign-in page.

const SIGN_IN_PAGES = /^\/(sign-in|sign-up|forgot-password|join|admin\/sign-in|admin\/forgot-password)(\/|$|\?)/;

/** `next` from an address, if it's a path on this site; otherwise `fallback`. */
export function safeNext(next: string | null | undefined, fallback: string): string {
  if (!next || !next.startsWith('/') || next.startsWith('//') || next.includes('\\')) {
    return fallback;
  }
  // A path that parses the same on this origin, with nothing hidden in it.
  try {
    const url = new URL(next, 'https://analytics.invalid');
    if (url.origin !== 'https://analytics.invalid' || SIGN_IN_PAGES.test(url.pathname)) {
      return fallback;
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return fallback;
  }
}

/** The sign-in page's address, coming back to `here` after. */
export function signInPath(pool: 'owners' | 'staff', here: string): string {
  const page = pool === 'staff' ? '/admin/sign-in' : '/sign-in';
  const back = safeNext(here, '');
  return back && back !== '/' ? `${page}?next=${encodeURIComponent(back)}` : page;
}
